import type { RevenueRange } from '../../../services/demoService';

export type { RevenueRange };

/** The seven progress-bar steps, plus the two terminal screens that sit outside it. */
export type BookDemoStep =
  | 'locations'
  | 'name'
  | 'revenue'
  | 'challenges'
  | 'review'
  | 'contact'
  | 'schedule'
  | 'belowThreshold'
  | 'success';

/**
 * Drives both the progress bar and every next/back hop. The name is asked first — opening on
 * who they are reads more personally than opening on how many locations they run.
 */
export const STEP_ORDER: BookDemoStep[] = [
  'name',
  'locations',
  'revenue',
  'challenges',
  'review',
  'contact',
  'schedule',
];

export interface BookDemoFormData {
  /** 1–20 when an exact count was picked, null when the user chose "20+". */
  restaurantCount: number | null;
  restaurantCount20Plus: boolean;
  businessName: string;
  revenueRange: RevenueRange | null;
  challenges: string[];
  contactName: string;
  email: string;
  phone: string;
  /** Honeypot — must stay empty; bots that fill it are rejected server-side. */
  website: string;
}

export const INITIAL_FORM_DATA: BookDemoFormData = {
  restaurantCount: 1,
  restaurantCount20Plus: false,
  businessName: '',
  revenueRange: null,
  challenges: [],
  contactName: '',
  email: '',
  phone: '',
  website: '',
};
